import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../http.service';
import { GlobalService } from '../global.service';
import { MatSlideToggleChange } from '@angular/material';

@Component({
  selector: 'app-businesswise-credit-amount',
  templateUrl: './businesswise-credit-amount.component.html',
  styleUrls: ['./businesswise-credit-amount.component.scss']
})
export class BusinesswiseCreditAmountComponent implements OnInit {

  // na_status: boolean = false;

  title = 'Bill Register';

  // Dropdown Data
  businessTypes = [
    { id: 1, name: 'Booth' },
    { id: 2, name: 'Milk & Fermented Products' },
    { id: 3, name: 'By Products' }
  ];
  paymentModes = [
    { value: '1', label: 'Bank Transfer' },
    { value: '2', label: 'Cash' },
    { value: '3', label: 'Cheque' }
  ];

  boothCodes = [
    { id: 101, code: 'Booth101' },
    { id: 102, code: 'Booth102' }
  ];

  otherInfo = 'Additional information here';  // Add your logic here if needed


  // Selected values
  selectedBusinessType: any;
  selectedBoothCode: any;
  selectedProductCategory: string;

  // Show/hide flags for details card
  showDetailsCard = false;

  // Filtered booth codes
  filteredBoothCodes = [];

  // Details data
  creditAmount = 5000;
  paymentReceived = 3000;
  balanceAmount = 2000;
  billDetails: any[] = [];  // All bills from API
  filteredBillDetails: any[] = [];  // Filtered list based on payment status
  selectedStatus: string = 'Not paid';  // Default filter value

  selectedBill: any = {}; // Store the selected bill here
  selectedtype = [];
  agent_code: any = null;
  booth_code: any = null;
  business_details: any = null;
  business_available = false;
  payment_modes: Object;
  selected_payment_mode = 2
  add_money_form: FormGroup;
  amount: any;
  selectamount: any;
  agent_id: any;
  min_date: string;
  transaction_history: Object;
  selectbusinesstype: any = [];
  selectbusinessgroup: any;
  selectbusinessgroups: any;
  Transaction_Id: any;
  business_group_id: any;
  business_type_id: any;
  transaction_id: any;
  deposit_amount: any;
  date: any;
  business_types: any = [];
  business_name: any = [];
  selectedOption: any;
  route_disabled = true;
  all_id_list = [];
  showBusinessGroupDropdown: boolean = true;
  showBusinessNamedropdown: boolean = true;
  businessGroup: string;
  selectbusinessname: any;
  Buisness_Name: boolean = false;
  Business_Group_Name: boolean = false
  business_code: any;
  businessCodes: any;
  selectboothcode: any
  business_codes: any;
  businessData: any = {};
  paymentForm: FormGroup;
  billno: any;
  balence_amt: any;
  paymentDetails: any;
  creditdata: any;
  receiveddata: any;
  balancedata: any;
  businessname: any;
  filterdata: any;
  bill_amount: any;
  today: string;


  constructor(private global: GlobalService, private http: HttpService, private formBuilder: FormBuilder) {
    this.paymentForm = this.formBuilder.group({
      paymentDate: ['', [Validators.required, this.dateValidator.bind(this)]],
      paymentAmount: ['', [Validators.required, this.amountValidator.bind(this)]],
      paymentMode: ['', Validators.required],
      na_status: [''],
      refNo: [''] // Optional or conditional, you can add Validators if necessary
    });
    // Set the today's date in yyyy-MM-dd format
    const currentDate = new Date();
    this.today = currentDate.toISOString().split('T')[0]; // This gives 'YYYY-MM-DD' format



    this.getbusinesstype()
  }

  // Custom validator to ensure selected date is not in the future
  dateValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const selectedDate = new Date(control.value);
    const currentDate = new Date(); // Today's date
    // Check if the selected date is in the future
    if (selectedDate > currentDate) {
      return { 'futureDate': true };
    }
    return null; // Return null if no validation error
  }

  amountValidator(control: AbstractControl): { [key: string]: boolean } | null {
    if (control.value > this.bill_amount) {
      return { 'amountExceeded': true };
    }
    return null;
  }

  getbusinesstype() {
    this.http.getBusinessType().subscribe((data) => {
      console.info(data);
      this.business_types = data['business_type'];
      console.info(this.business_types)
    });
  }

  resetFields() {
    this.paymentForm.reset(); // This will reset all form controls, including na_status
  }


  onbusinessselectname() {
    console.info(this.selectbusinessgroup)

    let data_dict = {
      'business_type_id': this.selectbusinessgroup,
    }
    console.info(data_dict);
    this.http.servebusinessname(data_dict).subscribe((data) => {
      console.log(data);
      this.business_name = data;
      console.info(this.business_name);

      this.business_codes = data['business_types']
      this.businessCodes = this.business_codes.map((businessType) => businessType.business_code);
      console.info(this.businessCodes);

      this.business_name['business_types'].forEach(element => {
        this.all_id_list.push(element.id)
      });
      console.info(this.business_name)
      this.selectedOption = this.all_id_list;
      console.info(this.selectedOption)

    }, (error) => {
      console.log(error);
    })
  }



  ngOnInit() {


  }





  onBusinessTypeChange() {
    if (this.selectedBusinessType === 1) {
      this.filteredBoothCodes = this.boothCodes;
    } else {
      this.filteredBoothCodes = [];
    }
  }

  // Handle Booth Code Selection
  onboothcodeselect() {
    console.log('Selected Booth Code:', this.selectboothcode);
  }

  // Handle Product Category Selection
  onProductCategorySelect() {
    console.info('Selected Product Category:', this.selectedProductCategory);
  }

  fetchDetails() {
    this.showDetailsCard = true
    const data_dict = {
      "search_type": this.selectedProductCategory,
      "booth_code": this.selectboothcode,
      "selection": this.selectedStatus
    };

    this.http.servebusinesscrdeidliitamount(data_dict).subscribe((data: any) => {
      this.filteredBillDetails = data.data;
      this.filterdata = data;

      // Assign values from response
      this.creditdata = this.filterdata['credit'];
      this.balancedata = this.filterdata['balence'];
      this.receiveddata = this.filterdata['received'];



      this.businessname = this.filterdata['name'];
      console.info(this.filteredBillDetails);
      this.filterBills();
    }, (error) => {
      console.log(error);
    });

  }

  filterBills() {
    const data_dict = {
      "search_type": this.selectedProductCategory,
      "booth_code": this.selectboothcode,
      "selection": this.selectedStatus
    };

    this.http.servebusinesscrdeidliitamount(data_dict).subscribe((data: any) => {
      this.filteredBillDetails = data.data;
      console.info(this.filteredBillDetails)


    }, (error) => {
      console.log(error);
    });
  }

  viewBill(bill) {
    this.billno = bill.bill_no;

    let data_dict = {
      "bill_no": this.billno,
      "na_status": false,
      "product": this.selectedProductCategory,
      "pay_view": true
    };

    // Call API to get the bill details
    this.http.savebusinesswisecreditamount(data_dict).subscribe(
      (data: any) => {
        this.paymentDetails = data.data; // Store API response in paymentDetails array
        console.log(this.paymentDetails);
        this.fetchDetails();

      },
      (error) => {
        console.log(error);
      }
    );
  }






  // Method to open the Update modal
  openUpdateModal(bill) {
    this.selectedBill = { ...bill }; // Copy the selected bill details
  }

  // Method to open the View modal
  openViewModal(bill) {
    this.selectedBill = { ...bill }; // Copy the selected bill details
  }

  onToggleChange(event: MatSlideToggleChange) {
    this.paymentForm.patchValue({ na_status: event.checked });
    console.info('NA Status:', this.paymentForm.value.na_status); // Log the NA status
  }

  saveUpdate() {
    const paymentAmount = this.paymentForm.value.paymentAmount;

    // Check if payment amount is greater than the bill amount
    if (paymentAmount > this.bill_amount && !this.paymentForm.value.na_status) {
      alert('Payment amount cannot be greater than the bill amount.');
      return; // Stop execution if payment amount exceeds the bill amount
    }

    let data_dict: any;

    if (this.paymentForm.value.na_status) {
      // If NA is true, send minimal data
      data_dict = {
        "bill_no": this.billno,
        "na_status": true,
        "product": this.selectedProductCategory,
        pay_view: 'false'
      };
    } else {
      // If NA is false, send full form data
      data_dict = {
        "bill_no": this.billno,
        "reference": this.paymentForm.value.refNo,
        "pay_amount": this.paymentForm.value.paymentAmount,
        "payment_id": this.paymentForm.value.paymentMode,
        "na_status": false,
        "balance_amount": this.balence_amt,
        "product": this.selectedProductCategory,
        "date": this.paymentForm.value.paymentDate,
        pay_view: 'True'
      };
    }

    // Call API with the constructed data_dict
    this.http.savebusinesswisecreditamount(data_dict).subscribe(
      (data: any) => {
        this.billDetails = data.data; // Assuming 'data.data' contains the bills list
        this.filterBills(); // Apply filtering after fetching the data
        this.fetchDetails();
        this.resetFields();
      },
      (error) => {
        console.log(error);
      }
    );
  }
  resetForm() {
    this.paymentForm.reset({
      na_status: false, // Reset toggle to off
      paymentDate: '',
      paymentAmount: '',
      paymentMode: '',
      refNo: ''
    });
  }


  editBill(bill) {
    console.info(bill)
    this.billno = bill.bill_no;
    this.balence_amt = bill.balence_amt
    this.bill_amount = bill.bill_amount


  }

}
